import React, { useEffect, useState } from "react"
import { ThemeProvider } from "emotion-theming"
import { light } from "@sumup/design-tokens"

import "./App.css"
import { Button, ButtonGroup, SearchInput, Select } from "@sumup/circuit-ui"
import ClipboardButton from "./ClipboardButton"
import Skeleton, { SkeletonTheme } from "react-loading-skeleton"

const PLACEHOLDER_PHOTOS = Array(8)
  .fill(null)
  .map(() => ({ loading: true }))

const PlaceHolderImage = ({ height = 250 }) => {
  return <Skeleton height={height} />
}

function App() {
  const [photos, setPhotos] = useState([])
  const [types, setTypes] = useState([])
  const [selectedType, setSelectedType] = useState<string | null>(null)
  const [query, setQuery] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)
  const [imageMap, setImageMap] = useState<Record<string, Array<number>>>({})

  const fetchAnimals = async () => {
    setLoading(true)
    setPhotos(PLACEHOLDER_PHOTOS as any)
    const typeParam = selectedType ? `?type=${selectedType}` : ""
    const queryParam = query ? `${typeParam ? "&" : "?"}query=${query}` : ""
    const response = await fetch(
      `${window.location.origin}/.netlify/functions/animals${typeParam}${queryParam}`
    )
    const { photos } = await response.json()

    setPhotos(photos)

    setLoading(false)
  }

  const fetchAnimalTypes = async () => {
    const response = await fetch(
      `${window.location.origin}/.netlify/functions/animal-types`
    )
    const { types } = await response.json()

    return types
  }

  useEffect(() => {
    const init = async () => {
      const types = await fetchAnimalTypes()

      setTypes(types)
    }

    init()
  }, [])

  return (
    <ThemeProvider theme={light}>
      <SkeletonTheme color='#626368' highlightColor='#6d6e74'>
        <div className='App'>
          <header
            style={{
              marginTop: "10rem",
              marginBottom: "3rem",
              color: "peachpuff",
            }}
          >
            <h1>cuuute</h1>
            <p>Cute animals for every PR</p>
          </header>
          <main className='App-main'>
            <section style={{ marginTop: "3rem", marginBottom: "3rem" }}>
              <div
                className='App-form-controls'
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "5rem",
                }}
              >
                <SearchInput onChange={(e: any) => setQuery(e.target.value)} />
                <Select
                  css={{ marginLeft: "1rem" }}
                  placeholder='All animals'
                  options={types.map((type: any) => ({
                    label: type.name,
                    value: type.name,
                  }))}
                  onChange={(e) => setSelectedType(e.target.value)}
                />
              </div>
              <ButtonGroup align='center' css={{ justifyContent: "center" }}>
                <Button css={{}} onClick={fetchAnimals} variant='primary'>
                  Search
                </Button>
                <Button css={{}} onClick={fetchAnimals} variant='secondary'>
                  I'm feeling lucky{" "}
                  <span role='img' aria-label='Happy cat'>
                    😸
                  </span>
                </Button>
              </ButtonGroup>
            </section>
            <section>
              <div
                className='App-image-list'
                style={{
                  display: "flex",
                  gap: "1rem",
                  flexWrap: "wrap",
                  justifyContent: "center",
                }}
              >
                {photos.map((p: any) => (
                  <div
                    key={p.large}
                    style={{
                      width: "calc(100% / 4 - 4rem)",
                      display: "flex",
                      flexDirection: "column",
                      borderRadius: 6,
                    }}
                  >
                    {!loading ? (
                      <>
                        {!imageMap[p.large] ? <PlaceHolderImage /> : null}
                        <img
                          style={{
                            visibility: imageMap[p.large]
                              ? "visible"
                              : "hidden",
                          }}
                          onLoad={(event) => {
                            const dimensions = [
                              (event.target as any)["height"] || 250,
                              (event.target as any)["width"],
                            ]

                            setImageMap((m) => ({
                              ...m,
                              [p.large]: dimensions,
                            }))
                          }}
                          src={p.large}
                          alt='animal'
                        />
                        <ClipboardButton
                          textForClipboard={`![animal](${p.large})`}
                        />
                      </>
                    ) : (
                      <PlaceHolderImage />
                    )}
                  </div>
                ))}
              </div>
            </section>
          </main>
        </div>
      </SkeletonTheme>
    </ThemeProvider>
  )
}

export default App
